// テキストボックスの初期値を設定
function setTextBoxDefaultValue(){
	var textBox = $("#textbox");
	// 駅名検索のサジェスト機能
	option = {
			minChars : 2,// 何文字からサジェストを始めるか
			minWidth : 235,// サジェストリストの最低横幅を決める
			extraParams : {'pref_cd' : $('input[name=pref]').val()},
			listID : function(data){return data['Station']['id'];}, // 各サジェスト候補のID（dataにJSONで取得してきた値が入っている）
			listInnerHTML : function(data){return data['Station']['name'];},
			listValue : function(data){return data['Station']['name'];},
			clickAddMethod : function(li){parent.location.href = createSuggestListURL(li.id);},
			emptyListInnerHTML : function(){var ul = document.createElement("ul"); var li = document.createElement("li"); li.innerHTML = "該当する駅がありません"; ul.appendChild(li); return ul;}
	}
	textBox.autocomplete('/station/get_autocomplete_json/',option);
}

/**
 * ページロード後に処理を走らせる
 */
$(function(){
	setTextBoxDefaultValue();
});